export function applyActors(store, actors) {
  let acting = false;

  store.subscribe(function () {
    if (!acting) {
      acting = true;
      _.forEach(actors, function (actor) {
        actor(store.getState(), store.dispatch);
      });
      acting = false;
    }
  });
}



// WEBPACK FOOTER //
// ./src/shared/utils/apply-actors.js